import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { requestJson } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type RiderAvailability = {
  available: boolean;
  suspended: boolean;
};

export function useRiderAvailability() {
  return useQuery({
    queryKey: queryKeys.riderAvailability.all(),
    queryFn: () => requestJson<{ availability: RiderAvailability }>("/api/rider/availability"),
    select: (data) => data.availability,
  });
}

export function useSetRiderAvailability() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (available: boolean) =>
      requestJson<{ availability: RiderAvailability }>("/api/rider/availability", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ available }),
      }),
    onSuccess: (data) => {
      qc.setQueryData(queryKeys.riderAvailability.all(), { availability: data.availability });
      qc.invalidateQueries({ queryKey: queryKeys.riderAvailability.all() });
    },
  });
}
